export const request = {
  javascript: [
    `var settings = {
  "url": "https://partner.tst.auws.cloud/v2/auth/signup/country/US/states",
  "method": "GET",
  "timeout": 0,
  "headers": {
    "X-AU-Key": "XXXX",
    "X-AU-Token": "XXXX"
  },
};

$.ajax(settings).done(function (response) {
  console.log(response);
});`,
  ],

  shell: [
    `wget --no-check-certificate --quiet 
--method GET 
--timeout=0 
--header 'X-AU-Key: XXXX' 
--header 'X-AU-Token: XXXX' 
'https://partner.tst.auws.cloud/v2/auth/signup/country/US/states'`,
  ],

  ruby: [
    `require "uri"
require "net/http"

url = URI("https://partner.tst.auws.cloud/v2/auth/signup/country/US/states")

https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true

request = Net::HTTP::Get.new(url)
request["X-AU-Key"] = "XXXX"
request["X-AU-Token"] = "XXXX"

response = https.request(request)
puts response.read_body`,
  ],

  python: [
    `import requests

url = "https://partner.tst.auws.cloud/v2/auth/signup/country/US/states"

payload={}
headers = {
  'X-AU-Key': 'XXXX',
  'X-AU-Token': 'XXXX'
}

response = requests.request("GET", url, headers=headers, data=payload)

print(response.text)`,
  ],
};

export const response = {
  success: [
    `{
  "status": "success",
  "data": {
    "states": [
      {
        "AL": "Alabama"
      },
      {
        "AK": "Alaska"
      },
      {
        "AZ": "Arizona"
      },
      {
        "AR": "Arkansas"
      },
      {
        "CO": "Colorado"
      },
      {
        "CT": "Connecticut"
      },
      {
        "DE": "Delaware"
      },
      {
        "DC": "District of Columbia"
      },
      {
        "FL": "Florida"
      },
      {
        "GA": "Georgia"
      },
      {
        "ID": "Idaho"
      },
      {
        "IL": "Illinois"
      },
      {
        "IA": "Iowa"
      },
      {
        "KS": "Kansas"
      },
      {
        "KY": "Kentucky"
      },
      {
        "LA": "Louisiana"
      },
      {
        "ME": "Maine"
      },
      {
        "MD": "Maryland"
      },
      {
        "MA": "Massachusetts"
      },
      {
        "MI": "Michigan"
      },
      {
        "MN": "Minnesota"
      },
      {
        "MS": "Mississippi"
      },
      {
        "MO": "Missouri"
      },
      {
        "MT": "Montana"
      },
      {
        "NE": "Nebraska"
      },
      {
        "NV": "Nevada"
      },
      {
        "NH": "New Hampshire"
      },
      {
        "NJ": "New Jersey"
      },
      {
        "NM": "New Mexico"
      },
      {
        "ND": "North Dakota"
      },
      {
        "MP": "Northern Mariana Islands"
      },
      {
        "OK": "Oklahoma"
      },
      {
        "OR": "Oregon"
      },
      {
        "RI": "Rhode Island"
      },
      {
        "SC": "South Carolina"
      },
      {
        "SD": "South Dakota"
      },
      {
        "TN": "Tennessee"
      },
      {
        "TX": "Texas"
      },
      {
        "UT": "Utah"
      },
      {
        "VT": "Vermont"
      },
      {
        "VA": "Virginia"
      },
      {
        "VI": "Virgin Islands"
      },
      {
        "WA": "Washington"
      },
      {
        "WV": "West Virginia"
      },
      {
        "WI": "Wisconsin"
      },
      {
        "WY": "Wyoming"
      }
    ]
  },
  "error": {},
  "message": "state list fetched successfully."
}`,
  ],
};
